export default __webpack_public_path__ + "static/media/IntroVid.511edfbb.mp4";